<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44.88 38.84">
    <path
      fill="currentColor"
      d="M44.88,12.9C44.88,5.38,39.08,0,33.16,0A11.17,11.17,0,0,0,22.44,7.9,11.17,11.17,0,0,0,11.72,0C5.8,0,0,5.38,0,12.9,0,24.3,17.49,37.35,21.8,38.72l.26.07a1.34,1.34,0,0,0,.35.05h.06a1.49,1.49,0,0,0,.36-.05l.25-.07C27.4,37.35,44.88,24.3,44.88,12.9Z"/>
  </svg>
</template>
